exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-complete-enter[data-v-283cd4f5], .list-complete-leave-to[data-v-283cd4f5] {\n    opacity: 0;\n}\n.list-complete-leave[data-v-283cd4f5] {\n    -webkit-transition: opacity 0.5s;\n    transition: opacity 0.5s;\n}\n.list-complete-enter-to[data-v-283cd4f5] {\n    -webkit-transition: opacity 1.5s;\n    transition: opacity 1.5s;\n}\n", ""]);

// exports
